export default __webpack_public_path__ + "static/media/Vestment of the Cackling Marionette.cc164317.jpg";